/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	SummerSchoolsReportDTO,
	SummerSchoolsReportDTOFromJSON,
	SummerSchoolsReportDTOFromJSONTyped,
	SummerSchoolsReportDTOToJSON,
} from "./SummerSchoolsReportDTO";

/**
 *
 * @export
 * @interface SummerSchoolsReportDTOPagedResponse
 */
export interface SummerSchoolsReportDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof SummerSchoolsReportDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof SummerSchoolsReportDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof SummerSchoolsReportDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<SummerSchoolsReportDTO>}
	 * @memberof SummerSchoolsReportDTOPagedResponse
	 */
	data?: Array<SummerSchoolsReportDTO> | null;
}

export function SummerSchoolsReportDTOPagedResponseFromJSON(
	json: any
): SummerSchoolsReportDTOPagedResponse {
	return SummerSchoolsReportDTOPagedResponseFromJSONTyped(json, false);
}

export function SummerSchoolsReportDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): SummerSchoolsReportDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(SummerSchoolsReportDTOFromJSON),
	};
}

export function SummerSchoolsReportDTOPagedResponseToJSON(
	value?: SummerSchoolsReportDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(SummerSchoolsReportDTOToJSON),
	};
}
